import {
  SiteModel,
  CostCenterModel,
  AssetCategoryModel,
  CountryEmergencyContacts,
} from "./models/asset.model";
import {
  ActionModel,
  FindingDetails,
  AssessmentModel,
  SiteAssessmentFindingsActionsModel,
} from "./models/assesment.model";
import {
  ActionReducer,
  ActionsReducer,
  FindingReducer,
  FindingsReducer,
} from "./reducers/finding.reducer";
import {
  LanguagesReducer,
  CategoriesReducer,
  CostCentersReducer,
  SiteSegmentsReducer,
  NationalEmergencyReducer,
} from "./reducers/master.reducer";
import {
  AssesmentReducer,
  AssesmentsReducer,
  AssessmentSiteReducer,
  SiteAssessmentsReducer,
} from "./reducers/assessment.reducer";
import {
  SAPconfigurationModel,
  ConnectionLocationMasterModel,
} from "./models/sap.model";
import {
  ConnectionReducer,
  ConnectionsReducer,
  ConnectionLocationsReducer,
} from "./reducers/connection.reducer";
import {
  SecurityPoiModel,
  SecurityCategoryModel,
} from "./models/site-security-mapping.model";
import {
  SecurityPoisReducer,
  SecurityCategoriesReducer,
} from "./reducers/site-security-mapping.reducer";
import { ActionReducerMap } from "@ngrx/store";
import { UserModel } from "./models/user.model";
import { UserReducer } from "./reducers/user.reducer";
import { SiteReducer } from "./reducers/asset.reducer";
import { LanguageModel } from "./models/language.model";
import { ConnectionModel } from "./models/connection.model";
import { NavigationModel } from "./models/navigation.model";
import { CurrencyReducer } from "./reducers/currency.reducer";
import { FeatureFlagModel } from "./models/featureFlag.model";
import { SiteSegmentModel } from "./models/siteSegment.model";
import { NavigationReducer } from "./reducers/navigation.reducer";
import { SAPConfigurationsReducer } from "./reducers/sap.reducer";
import { SegmentMastersModel } from "./models/segment-master.model";
import { featureFlagsReducer } from "./reducers/featureFlag.reducer";
import { BogCurrencyInformationModel } from "./models/currency.model";
import { ModuleReducer, ModuleState } from "./reducers/module.reducer";
import { ActionManagementModel } from "./models/action-management.model";
import { SegmentMastersReducer } from "./reducers/segment-masters.reducer";
import { ActionManagementReducer } from "./reducers/action-management.reducer";

export interface StoreState {
  user: UserModel;
  site: SiteModel;
  action: ActionModel;
  actions: ActionModel[];
  finding: FindingDetails;
  moduleState: ModuleState;
  assessmentSite: SiteModel;
  findings: FindingDetails[];
  languages: LanguageModel[];
  assesment: AssessmentModel;
  navigation: NavigationModel;
  assesments: AssessmentModel[];
  costCenters: CostCenterModel[];
  connections: ConnectionModel[];
  featureFlags: FeatureFlagModel[];
  categories: AssetCategoryModel[];
  siteSegments: SiteSegmentModel[];
  securityPois: SecurityPoiModel[];
  selectedConnection: ConnectionModel;
  segmentMasters: SegmentMastersModel;
  currency: BogCurrencyInformationModel;
  actionManagement: ActionManagementModel;
  sapConfigurations: SAPconfigurationModel[];
  securityCategories: SecurityCategoryModel[];
  nationalEmergencies: CountryEmergencyContacts[];
  siteAssessments: SiteAssessmentFindingsActionsModel;
  connectionLocations: ConnectionLocationMasterModel[];
}

export const Reducer: ActionReducerMap<StoreState> = {
  user: UserReducer,
  site: SiteReducer,
  action: ActionReducer,
  finding: FindingReducer,
  actions: ActionsReducer,
  findings: FindingsReducer,
  currency: CurrencyReducer,
  moduleState: ModuleReducer,
  assesment: AssesmentReducer,
  languages: LanguagesReducer,
  categories: CategoriesReducer,
  assesments: AssesmentsReducer,
  navigation: NavigationReducer,
  costCenters: CostCentersReducer,
  connections: ConnectionsReducer,
  featureFlags: featureFlagsReducer,
  siteSegments: SiteSegmentsReducer,
  securityPois: SecurityPoisReducer,
  assessmentSite: AssessmentSiteReducer,
  segmentMasters: SegmentMastersReducer,
  selectedConnection: ConnectionReducer,
  siteAssessments: SiteAssessmentsReducer,
  actionManagement: ActionManagementReducer,
  sapConfigurations: SAPConfigurationsReducer,
  securityCategories: SecurityCategoriesReducer,
  nationalEmergencies: NationalEmergencyReducer,
  connectionLocations: ConnectionLocationsReducer,
};
